import React from 'react';
import Header from '../components/Header';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import { FileCheck, ExternalLink } from 'lucide-react';

const SSR = () => {
  const ssrDocuments = [
    {
      title: 'Self Study Report (SSR) - Cycle 3',
      description: 'Complete Self Study Report for NAAC Accreditation',
      link: '#'
    },
    {
      title: 'Institutional Information for Quality Assessment (IIQA)',
      description: 'Annual Quality Assurance Report',
      link: '#'
    },
    {
      title: 'Annual Quality Assurance Report (AQAR) 2022-23',
      description: 'Quality initiatives and achievements',
      link: '#'
    },
    {
      title: 'Student Satisfaction Survey Report',
      description: 'Feedback analysis and action taken',
      link: '/student'
    },
    {
      title: 'NAAC Peer Team Report',
      description: 'Assessment and recommendations',
      link: '#'
    },
    {
      title: 'Strategic Plan 2020-2025',
      description: 'Institutional development roadmap',
      link: '#'
    }
  ];

  const criteria = [
    { number: 'I', title: 'Curricular Aspects', status: 'Completed' },
    { number: 'II', title: 'Teaching-Learning and Evaluation', status: 'Completed' },
    { number: 'III', title: 'Research, Innovations and Extension', status: 'Completed' },
    { number: 'IV', title: 'Infrastructure and Learning Resources', status: 'Completed' },
    { number: 'V', title: 'Student Support and Progression', status: 'Completed' },
    { number: 'VI', title: 'Governance, Leadership and Management', status: 'Completed' },
    { number: 'VII', title: 'Institutional Values and Best Practices', status: 'Completed' }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <Navigation />
      
      <div className="container mx-auto px-4 py-8">
        <div className="mb-8">
          <h1 className="text-4xl font-bold text-[#000066] mb-2 flex items-center gap-3">
            <FileCheck className="w-10 h-10" />
            NAAC Documents and SSR Links
          </h1>
          <p className="text-gray-600">Self Study Report and Quality Assurance Documents</p>
        </div>

        {/* NAAC Grade */}
        <div className="bg-gradient-to-r from-[#000066] to-[#000099] text-white p-8 rounded-lg shadow-lg mb-8">
          <div className="text-center">
            <h2 className="text-3xl font-bold mb-2">NAAC Accreditation Status</h2>
            <p className="text-5xl font-bold text-[#FFD700] my-4">Grade 'A'</p>
            <p className="text-xl">CGPA: 3.01</p>
            <p className="mt-2 text-sm">Valid until: March 2027</p>
          </div>
        </div>

        {/* Seven Criteria */}
        <div className="mb-8">
          <h2 className="text-2xl font-bold text-[#000066] mb-4">NAAC Seven Criteria</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
            {criteria.map((criterion, index) => (
              <div
                key={index}
                className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow border-l-4 border-[#FF4500]"
              >
                <div className="flex items-center justify-between mb-2">
                  <span className="text-3xl font-bold text-[#000066]">{criterion.number}</span>
                  <span className="text-xs bg-green-100 text-green-800 px-2 py-1 rounded-full">
                    {criterion.status}
                  </span>
                </div>
                <h3 className="text-sm font-semibold text-gray-700">{criterion.title}</h3>
              </div>
            ))}
          </div>
        </div>

        {/* SSR Documents */}
        <div>
          <h2 className="text-2xl font-bold text-[#000066] mb-4">Important Documents</h2>
          <div className="grid gap-6">
            {ssrDocuments.map((doc, index) => (
              <div
                key={index}
                className="bg-white rounded-lg shadow-lg p-6 hover:shadow-xl transition-all duration-300"
              >
                <div className="flex items-start justify-between">
                  <div className="flex-1">
                    <h3 className="text-xl font-bold text-[#000066] mb-2">
                      {doc.title}
                    </h3>
                    <p className="text-gray-600 mb-4">{doc.description}</p>
                  </div>
                  <a
                    href={doc.link}
                    className="ml-4 px-4 py-2 bg-[#FF4500] text-white rounded hover:bg-[#FF5722] transition-colors inline-flex items-center gap-2"
                  >
                    View
                    <ExternalLink className="w-4 h-4" />
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default SSR;